import {Component, OnInit, OnDestroy, ViewChild} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {MatSort} from '@angular/material/sort';
import {MatTableDataSource} from '@angular/material/table';
import {SitePublicService} from 'src/app/services/site-public.service';
import {SnackBarIconService} from 'src/app/shared/snack-bar-icon/snack-bar-icon.service';
import {SpinnerService} from 'src/app/shared/waiting/spinner.service';
import {StatuteDialogComponent} from '../../dialogs/statute-dialog/statute-dialog.component';
import {ConfirmComponent} from 'src/app/shared/dialogs/confirm/confirm.component';
import {Subscription} from 'rxjs';

@Component({
  selector: 'app-statute',
  templateUrl: './statute.component.html',
  styleUrls: [ './statute.component.scss' ]
})
export class StatuteComponent implements OnInit, OnDestroy {

  public dataSource: MatTableDataSource<any>
  public displayedColumns: string[] = [ 'icon', 'position', 'title', 'edit', 'delete' ];

  @ViewChild(MatSort, {static: true}) sort: MatSort;

  private statuteSubscription: Subscription | undefined;

  public selectedPDF: any;
  public pdfDocument$: any;

  constructor (
    private _sitePublicService: SitePublicService,
    private _dialog: MatDialog,
    private _spinnerService: SpinnerService,
    private _snackBar: SnackBarIconService,) {

    /*
    if (!this._authService.isAdmin) {
    this.router.navigate([ 'home' ]);
    }
    */

    this.loadStatute()
  }

  ngOnInit () {
    const documentKey = 'statute';
    this.pdfDocument$ = this._sitePublicService.getPDFByKey(documentKey);
    //console.log("pdfDocument$: " + JSON.stringify(this.pdfDocument$))
  }

  ngOnDestroy () {
    if (this.statuteSubscription) {
      this.statuteSubscription.unsubscribe();
    }
  }

  applyFilter (filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  loadStatute () {
    const waiting = this._spinnerService.show();

    // 1. Chama o serviço que retorna o Observable
    const statute$ = this._sitePublicService.loadStatute();

    // 2. Se inscreve no Observable
    this.statuteSubscription = statute$.subscribe({
      next: (array: any[]) => {
        // Este código será executado na primeira vez E em cada mudança subsequente.
        this.dataSource = new MatTableDataSource(array);
        this.dataSource.sort = this.sort;
        // O 'waiting.close()' deve ser feito apenas na primeira vez.
        // Uma forma simples é verificar se o spinner está aberto ou usar 'finalize' no pipe.
        // Aqui, vamos apenas fechar, assumindo que já está aberto.
        if (waiting) {
          waiting.close();
        }
      },
      error: (error) => {
        console.error('Erro ao carregar o estatuto:', error);
        if (waiting) {
          waiting.close();
        }
        // Trate o erro (ex: exibir mensagem para o usuário)
      },
      // O complete não é chamado, pois é um Observable "infinito" (tempo real)
    });
  }

  openDialog (entity: any) {

    let data: any = {};
    if (entity) {
      data = entity;
    } else {
      data = {'id': "0", 'position': 0, 'title': '', 'text': ''};
    }

    let dialogRef = this._dialog.open(StatuteDialogComponent, {
      //width: '900px',
      //height: '680px',
      width: window.innerWidth.toString() + "px",
      height: window.innerHeight.toString() + "px",
      panelClass: 'custom-dialog-container',
      data: data
    });

    dialogRef.afterClosed()
      .subscribe(async (response) => {
        if (!response) {
          return;
        }

        const actionType: string = response[ 0 ];
        const form: any = response[ 1 ];
        const formData = form.getRawValue();

        if (actionType == 'insert') {

          // console.log("insert: " + JSON.stringify(formData));
          delete formData.id;

          await this._sitePublicService.insertStatute(formData)
            .then(async () => {
              this._snackBar.openSnackBar("Sucesso!", '', 'success')
            })
            .catch((err: any) => {
              console.log("erro ao adicionar bienio")
              this._snackBar.openSnackBar("Erro!", '', 'error')
            });

        } else {
          // console.log("update: " + JSON.stringify(formData));
          const id = formData.id;
          const data = formData

          await this._sitePublicService.updateStatute(id, data)
            .then(async () => {
              this._snackBar.openSnackBar("Sucesso!", '', 'success')
            })
            .catch((err: any) => {
              console.log("erro ao atualizar bienio")
              this._snackBar.openSnackBar("Erro!", '', 'error')
            });

        }
      })

  }

  delete (element) {
    let dialogRef = this._dialog.open(ConfirmComponent, {
      width: '350px',
      height: '270px',
      panelClass: 'custom-dialog-container',
      data: {title: "Confirme", message: element.period + "<br><br>Excluir este período?"}
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result == "ok") {

        this._sitePublicService.deleteBiennium(element.id)
          .then(
            () => {
              this._snackBar.openSnackBar("Sucesso!", '', 'success')
            }
          )
          .catch(
            (error) => {console.log("delete regional error: " + error.message)}
          )
      }
    })
  }

  pdfChange (data: any) {
    const file: File = data.target.files[ 0 ]
    this.selectedPDF = file
    console.log(this.selectedPDF.name);
  }

  async savePDF () {
    const file: File = this.selectedPDF;
    const key: string = 'statute'

    try {
      const url = await this._sitePublicService.uploadPDF(file, key, "pub_pdfs");
      console.log("Upload e registro concluídos. URL:", url);
      // Faça algo com a URL (ex: atualizar o formulário, exibir sucesso)
    } catch (error) {
      console.error("Erro durante o processo de upload/registro:", error);
      // Trate o erro (ex: exibir mensagem para o usuário)
    }
  }

  openDeletePDF (documentKey: string) {
    let dialogRef = this._dialog.open(ConfirmComponent, {
      width: '350px',
      height: '270px',
      panelClass: 'custom-dialog-container',
      data: {title: "Confirme", message: "<br><br>Deseja excluir este pPDF?"}
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result == "ok") {
        this.deletePDF(documentKey)
      }
    })

  }

  async deletePDF (documentKey: string) {
    const waiting = this._spinnerService.show();

    try {
      // Chama a função e aguarda a conclusão da exclusão do Firestore e do Storage
      await this._sitePublicService.deletePDF('pub_pdfs', documentKey);

      // Exibe feedback de sucesso e atualiza a interface (ex: recarrega a lista)
      console.log(`Registro e arquivo deletados com sucesso: ${ documentKey }`);
      this.loadStatute(); // Exemplo: recarrega os dados na tabela

    } catch (error) {
      console.error("Não foi possível completar a exclusão:", error);
      // Exibir mensagem de erro para o usuário
    } finally {
      waiting.close();
    }
  }

}
